import { render, staticRenderFns } from "./StatsDashboardDialog.vue?vue&type=template&id=5a5cc1fa&"
import script from "./StatsDashboardDialog.vue?vue&type=script&lang=js&"
export * from "./StatsDashboardDialog.vue?vue&type=script&lang=js&"
import style0 from "./StatsDashboardDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports